import { IconSword, IconHeart, IconShieldCheck, IconBolt, IconSparkles,
  IconSpeakerphone, IconRefresh, IconSpiral, IconStar } from '../../components/icons.jsx';

// Shared tones keep card modifiers consistent with active effects on the arena.
export const EFFECT_STYLES = {
  'Исцеление': ['healing', IconHeart],
  'Кровотечение': ['harmful', IconHeart],
  'Боевой клич': ['power', IconBolt],
  'Оглушение': ['harmful', IconBolt],
  'Барьер': ['defense', IconShieldCheck],
  'Железная защита': ['defense', IconShieldCheck],
  'Энергетический барьер': ['defense', IconShieldCheck],
  'Отражающий барьер': ['defense', IconShieldCheck],
  'Шипы': ['harmful', IconSword],
};

const CARD_STYLES = {
  ...EFFECT_STYLES,
  'Боевой клич': ['power', IconSpeakerphone],
  'Мощный удар': ['power', IconSword],
  'Финальный удар': ['power', IconStar],
  'Критический удар': ['power', IconSparkles],
  'Рывок': ['power', IconBolt],
  'Неуязвимость': ['defense', IconShieldCheck],
  'Зеркало': ['special', IconRefresh],
  'Оглушение': ['harmful', IconSpiral],
};

export function ArenaModifierIcon({ modifier }) {
  if (!modifier) return null;
  const [tone, Icon] = CARD_STYLES[modifier] || ['special', IconSparkles];
  return <span className={`battle-card-modifier battle-card-modifier-${tone}`}
    role="img" aria-label={modifier} title={modifier}><Icon aria-hidden="true" /></span>;
}
